import { arrayOf, bool, eventListener, object, oneOf } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { GalleryType } from './gallery-constants.js';
const GalleryProperties = {
    data: {
        defaultValue: [],
        type: arrayOf(object).notEnumerable(),
    },
    onDelete: {
        type: eventListener,
    },
    selectable: {
        defaultValue: false,
        type: bool,
    },
    type: {
        defaultValue: GalleryType.DEFAULT,
        type: oneOf(enumValues(GalleryType)),
    },
};
export { GalleryProperties, };
//# sourceMappingURL=gallery-types.js.map